import { createSlice } from "@reduxjs/toolkit";

export interface BatchState {
  isAssignCartModalOpen: boolean;
}

const initialState: BatchState = {
  isAssignCartModalOpen: false
};

export const batchSlice = createSlice({
  name: "batch",
  initialState,
  reducers: {
    closeAssignCartModal(state) {
      state.isAssignCartModalOpen = false;
    },
    openAssignCartModal(state) {
      state.isAssignCartModalOpen = true;
    }
  }
});

export const { closeAssignCartModal, openAssignCartModal } = batchSlice.actions;
